/**
 * Created by Vivian on 2018/8/7.
 */
import Vue from 'vue'
import VeeValidate from 'vee-validate'

VeeValidate.Validator.extend('phone', {
  getMessage (filed, params, data) {
    return (data && data.message) || 'phone number is wrong'
  },
  validate (value) {
    let _reg = /^0?(13[0-9]|15[0-9]|17[0-9]|18[0-9]|14[0-9])[0-9]{8}$/
    return _reg.test(value)
  }
})
VeeValidate.Validator.extend('t-m-phone', {
  getMessage (filed, params, data) {
    return (data && data.message) || 'you have a wrong number'
  },
  validate (value) {
    let mReg = /^0?(13[0-9]|15[0-9]|17[0-9]|18[0-9]|14[0-9])[0-9]{8}$/
    let tReg = /^0\d{2,3}-\d{7,8}(-\d{1,4})?$/
    return tReg.test(value) || mReg.test(value)
  }
})
// VeeValidate.Validator.addLocale(messageCn)

Vue.use(VeeValidate, {
  locale: 'zh_CN'
})



// WEBPACK FOOTER //
// ./src/utils/some-other.js